// @flow

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {InputAdornment, Typography, makeStyles} from '@material-ui/core';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {HexColorPicker} from 'react-colorful';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
type Props = {
  open: boolean,
  handleClose: () => void,
  onSelectColor: (color: string) => void,
};

const useStyles = makeStyles(theme => ({
  modal: {
    // padding: theme.spacing(2),
    '& .MuiPaper-root': {
      padding: theme.spacing(2),
      maxWidth: '90%',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 420,
    maxWidth: '100%',
    padding: theme.spacing(2),
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '24px',
    marginTop: theme.spacing(2),
  },
  colorPickerWrap: {
    margin: theme.spacing(2, 0),
    height: '320px!important',
    width: '320px!important',
    maxWidth: '100%!important',
  },
  colorPreview: {
    width: 56,
    height: 48,
    borderRadius: 12,
  },
  briefWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    width: 320,
    maxWidth: '100%',
  },
  textField: {
    '& input': {
      padding: '12px 10px!important',
    },
  },
  inputAdornment: {
    marginTop: '0!important',
  },
  saveBtn: {
    margin: theme.spacing(2, 0),
  },
}));

// const HEX_REGEX = /^#[0-9a-fA-F]{0,6}$/;

function ColorOptionModal({open, handleClose, onSelectColor}: Props) {
  const [color, setColor] = useState<string>('#753d3d');

  const classes = useStyles();

  const handleSaveColorOption = () => {
    onSelectColor(color);
    handleClose();
  };

  const handleHexColorChange = event => {
    let inputValue: string = event.target.value;

    if (!inputValue.startsWith('#')) {
      inputValue = `#${inputValue}`;
    }

    setColor(inputValue);
  };

  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modal}
    >
      <div className={classes.root}>
        <Typography className={classes.title}> Definir color</Typography>

        <div>
          <HexColorPicker
            color={color}
            onChange={setColor}
            className={classes.colorPickerWrap}
          />
        </div>

        <div className={classes.briefWrap}>
          <div
            className={classes.colorPreview}
            style={{background: `#${color.replace('#', '')}`}}
          />
          <CustomTextField
            value={color.replace('#', '')}
            onChange={handleHexColorChange}
            classes={{
              root: classes.textField,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  classes={{root: classes.inputAdornment}}
                >
                  <Typography>Hex #</Typography>
                </InputAdornment>
              ),
              inputProps: {
                maxLength: 6,
                pattern: '^(?:[0-9a-fA-F]{3}){1,2}$',
              },
            }}
          />
        </div>

        <CustomButton
          className={classes.saveBtn}
          variant="contained"
          onClick={handleSaveColorOption}
        >
          Confirmar
        </CustomButton>
      </div>{' '}
    </CustomModal>
  );
}

ColorOptionModal.propTypes = {
  open: PropTypes.bool,
};

export default ColorOptionModal;
